// extracted by mini-css-extract-plugin
module.exports = {"ingLinkStyles":"INGHeaderLogo_ingLinkStyles__2UUum","ingLogosStyle":"INGHeaderLogo_ingLogosStyle__15giL"};